import styled from 'styled-components'
import { useTranslation, Trans } from 'react-i18next'
import { showTrustScoreInfoModal } from './base'
import InfoIcon from './info-icon'
import identity from './images/info.png'

const StepWrapper = styled.div`
  display: flex;
  text-align: left;
  margin-bottom: 20px;
`

const StepNumber = styled.div`
  width: 24px;
  height: 24px;
  background-color: #e9f2fc;
  border-radius: 50%;
  font-size: 12px;
  color: #3e5b77;
  margin-right: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-shrink: 0;
`

const IdentityVerification = props => {
  const { t } = useTranslation()
  return (
    <InfoIcon
      {...props}
      onClick={() =>
        showTrustScoreInfoModal({
          title: t('b.liv_score.view.identity_verification.title', 'Identity Verification'),
          description: (
            <Trans i18nKey="b.liv_score.view.identity_verification.text">
              <span>
                <strong>Identity Verification</strong> requires renters to complete a two-step
                process within their liv.rent profile:
              </span>
              <StepWrapper>
                <StepNumber>1</StepNumber>
                Renters first upload a picture of their valid, government-issued photo ID (e.g.
                driver's license, passport, permanent residence card)
              </StepWrapper>
              <StepWrapper>
                <StepNumber>2</StepNumber>
                They're then prompted to take and upload a "selfie" to corroborate their identity
              </StepWrapper>
              <span>
                These two images are manually checked by the liv.rent team to ensure a match.
              </span>
            </Trans>
          ),
          image: identity
        })
      }
    />
  )
}

export default IdentityVerification
